<template>
  <div>
    <div class="bg-content padding15">
      <el-form size="small" label-width="140px" label-position="left">
        <el-row :gutter="24">
          <el-form-item label="当前密码">
            <el-col :span="9">
              <el-input type="password" v-model="passReq.oldPassword" placeholder="请输入当前密码"/>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="新密码">
            <el-col :span="9">
              <el-input type="password" v-model="passReq.password" placeholder="请输入新密码"/>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="确认密码">
            <el-col :span="9">
              <el-input type="password" v-model="passReq.confirm" placeholder="请输入确认密码"/>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="9">
            <el-button type="primary" size="small" style="margin-left: 40%;" @click="update">保存</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      passReq: {
        oldPassword: null,
        password: null,
        confirm: null
      }
    };
  },
  methods: {
    update() {
      if (this.passReq.password !== this.passReq.confirm) {
        this.$notify.error({
          title: '提示',
          message: '两次密码输入不一致'
        });
        return;
      }
      this.$confirm('您确定要保存吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/user/reset-password',
          method: 'POST',
          data: this.passReq
        });
      });
    }
  },
  mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/userCenter/pass.vue